module.exports = __webpack_public_path__ + "img/77438.5d7a48e1.svg";